import React from 'react';
import { AppProvider } from './context/AppContext';
import { SubdomainProvider } from './contexts/SubdomainContext';
import { EfemLockProvider } from './context/EfemLockContext';
import { InsightApp } from './components/InsightApp';
import AmplifyAuthWrapper from './components/auth/AmplifyAuthWrapper';
import { AppThemeProvider } from './theme/AppThemeProvider';

const App: React.FC = () => {
  return (
    <AppProvider>
      <AppThemeProvider>
        <AmplifyAuthWrapper>
          <SubdomainProvider>
            <EfemLockProvider>
              <InsightApp />
            </EfemLockProvider>
          </SubdomainProvider>
        </AmplifyAuthWrapper>
      </AppThemeProvider>
    </AppProvider>
  );
};

export default App;
